<!-- 表单的筛选 -->
<template>
    <div>
        <el-button
        type="danger"
        size="mini"
        class="column__tool__buttom"
        @click="onClickDelete()"
        >删除</el-button>
    </div>    
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { deleteApi } from '@/api/core/table/table';

export default {
  name: "DeleteTableBtn",
  
  mixins: [BaseVue],
  
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      tagclass: "info",
      tagtext: ""
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    onClickDelete() {
      this.$confirm(`确定要删除"${this.title}"吗？`, "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "放弃"
      }).then(() => {
        deleteApi(this.serverUrl, this.id)
          .then(() => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$emit("onSuccess");
          })
          .catch(error => {
            console.log(error);
            this.$message.error("删除失败");
          });
      })
    }
  },
  
  mounted() {
    this.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
